import React, { useCallback } from "react";
import "./Modal.scss";
import { ReactComponent as Close } from "../../assets/x.svg";
import Button from "../Button/Button";

export const Modal = ({
  isVisible,
  onClose,
  title,
  onSave,
  onDelete,
  saveText = "Guardar",
  deleteText = "Apagar",
  children,
  disableActions = false,
  disableBackdropClose = false,
}) => {
  const handleBackdropClick = useCallback(
    (e) => {
      if (e.target !== e.currentTarget) return; // click dentro do modal
      if (disableActions || disableBackdropClose) return;
      onClose?.();
    },
    [disableActions, disableBackdropClose, onClose]
  );

  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape" && !disableActions && !disableBackdropClose) {
        onClose?.();
      }
    },
    [disableActions, disableBackdropClose, onClose]
  );

  // se o modal não estiver visível, não renderiza nada
  if (!isVisible) return null;

  return (
    <div
      className={`modal-backdrop ${disableActions ? "is-busy" : ""}`}
      onClick={handleBackdropClick}
      onKeyDown={handleKeyDown}
      tabIndex={-1} // recebe foco para capturar ESC
      aria-busy={disableActions}
      aria-modal="true"
      role="dialog"
    >
      <div className="modal">
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-header">
              <h5>{title}</h5>
              <button className="close-btn" onClick={onClose}>
                <Close />
              </button>
            </div>

            <div className={`modal-body ${disableActions ? "is-busy" : ""}`}>
              <fieldset
                disabled={disableActions}
                style={{ border: 0, padding: 0, margin: 0 }}
              >
                {children}
              </fieldset>
            </div>

            <div className="modal-footer">
              {onDelete && (
                <Button
                  variant="danger"
                  onClick={onDelete}
                  type="button"
                  disabled={disableActions}
                >
                  {deleteText}
                </Button>
              )}
              {!onDelete && (
                <Button
                  variant="secondary"
                  onClick={onClose}
                  type="button"
                  disabled={disableActions}
                >
                  Fechar
                </Button>
              )}
              {onSave && (
                <Button
                  variant="primary"
                  onClick={onSave}
                  type="button"
                  disabled={disableActions}
                >
                  {saveText}
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
